import {getAccountsForPortfolioGrowth, getFormattedDateRangeForPortfolioGrowth} from './PortfolioGrowthFilterSelectors';
import { createSelector } from 'reselect';
import {isBetweenFromAndToDates} from 'services/Dates';

/** Copyright (c) 2021 T. Rowe Price. All rights reserved. */

export const getPortfolioGrowthForPerformance = (state) => state.growth;

export const getPortfolioGrowthForGivenRange = createSelector(
  getPortfolioGrowthForPerformance,
  getFormattedDateRangeForPortfolioGrowth,
  (growth, dateRange) => {
    const filteredGrowth = growth.filter((period) => {
      return (
          isBetweenFromAndToDates(period.date, dateRange.fromDate, dateRange.toDate)
      );
    });
    return filteredGrowth;
  }
);

//filtering portfolio growth accounts that have share class conversion
export const portfolioGrowthAccountsWithShareClass  = createSelector(
  getAccountsForPortfolioGrowth,
  (accounts) => accounts.filter((account) => account?.shareClassConversion));